import Form from '../../../components/form';

function initialiseForms() {
	const forms = document.querySelectorAll('.c-form');
	if (forms.length > 0) {
		forms.forEach((e) => {
			const form = new Form(e);
			form.init();
		});
	}
}

export default initialiseForms;
